import {api} from './api';
import {ChangePasswordRequest, User} from '../types/user';

interface ApiResponse<T> {
    code: string;
    success: boolean;
    message: string;
    data: T;
}

export const userService = {
    /**
     * 获取当前用户信息
     */
    getCurrentUser: async (): Promise<User> => {
        const response = await api.get<ApiResponse<User>>('/api/v1/users/me');
        if (!response.data.success) {
            throw new Error(response.data.message || '获取用户信息失败');
        }
        return response.data.data!;
    },

    /**
     * 修改密码
     */
    changePassword: async (request: ChangePasswordRequest): Promise<void> => {
        const response = await api.put<ApiResponse<null>>('/api/v1/users/password', request);
        if (!response.data.success) {
            throw new Error(response.data.message || '修改密码失败');
        }
    },
};
